import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { mergeMap, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AudioPlayerService {
  private readonly http = inject(HttpClient);

  private singleAudio: HTMLAudioElement | null = null;

  play = (audioFile: string, playbackSpeed: number = 1): Observable<MediaError | undefined> => {
    // Separately fetch the audio blob instead of new Audio("url") to help with debugging iOS audio playback errors (failed to decode)
    // Hopefully temporary
    const file$ = this.http.get(`${environment.AssetServerURL}/assets/` + audioFile, { responseType: 'blob' });

    return file$.pipe(
      mergeMap(f => {
        const objectUrl = URL.createObjectURL(f);
        const audioElement = new Audio(objectUrl);

        audioElement.playbackRate = playbackSpeed;
        let audioObservable = new Observable<MediaError | undefined>((observer) => {
          this.stopAll();
          let completeHandler = () => {
            observer.next(undefined);
            observer.complete();
          }
          let errorHandler = () => {
            console.error('AudioPlayerService.play error playing ', audioFile, ' is of length ', f.size, ':', audioElement.error);
            observer.error(audioElement.error);
          }

          audioElement.addEventListener('ended', completeHandler);
          audioElement.addEventListener('error', errorHandler);

          audioElement.play().catch((error) => {
            observer.error(error);
          });
          this.singleAudio = audioElement;

          return {
            unsubscribe() {
              audioElement.removeEventListener('ended', completeHandler);
              audioElement.removeEventListener('error', errorHandler);
              URL.revokeObjectURL(objectUrl);
            }
          }
        });

        return audioObservable;
      })
    );
  }

  stopAll = () => {
    if ((this.singleAudio) && !this.singleAudio.paused) {
      this.singleAudio.pause();
      this.singleAudio.currentTime = 0;
      this.singleAudio = null;
    }
  }
 }
